import $ from "jquery";
import { Modal } from "bootstrap";
import Cookies from "js-cookie";

export const SpielbodenUI = {

    init_loader(fade) {
        $("div.next_mon_loader").hide();
        var loader = $("div.loader");
        if(loader) {
            loader.height($("#portal-columns").height());
            if (fade) {
                loader.fadeOut();
            } else {
                loader.hide();
            }
        }

        // BS5 tooltips
        // see https://getbootstrap.com/docs/5.0/components/tooltips/
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    },

    load_content(href) {
        $("div.loader").show();
        $("#content").load(href + (href.indexOf("?") == -1 ? "?" : "&") + "ajax_load=" + (new Date().getTime()) + " #content > *", () => {
            this.init_loader(true);
        });
    },

    load_month(href, click_dom) {
        $("div.loader").show();
        $('<div class="row eventMonth" />').load(href + (href.indexOf("?") == -1 ? "?" : "&") + "ajax_load=" + (new Date().getTime()) + " #content > *", (response, error) => {
            var month = $(click_dom).parents("div.eventMonth");
            var scroll_to = month.offset().top - 100;
            month.replaceWith($(response).find("div.eventMonth"));
            this.init_loader(true);
            $("html,body").animate({
                scrollTop: scroll_to
            });
        });
    },

    load_info_modal() {
        const info_mod = document.querySelector("#spielboden-infopopup");
        if(!info_mod) {
            return;
        }
        const info_modal = new Modal(info_mod);
        document.getElementById("portal-logo").classList.add("flyin");
        window.setTimeout(() => {
            info_modal.show();
        }, 500);
        info_mod.addEventListener("hidden.bs.modal", (event) => {
            document.getElementById("portal-logo").classList.remove("flyin");
        });
    },

    load_info_offcanvas() {
        let cookies = document.cookie
        const info = document.getElementById("infoOffcanvas");
        if (info && cookies.indexOf("spielbodenInfoDismiss") == -1) {
            const info_off = new bootstrap.Offcanvas('#infoOffcanvas');
            window.setTimeout(() => {
                info_off.show();
            }, 1000);
            info.addEventListener('hide.bs.offcanvas', (event) => {
                let expires = new Date(Date.now() + 86400e3);
                document.cookie = `spielbodenInfoDismiss=1; expires=${expires.toUTCString()}`;
            });
        }
    },

    scroll_to_lastmon() {
        var last_mon = $("div.eventMonth:last");
        if (last_mon.length > 0) {
            $("html,body").animate({
                scrollTop: last_mon.offset().top
            });
        }
    },

    async init() {
        window.setTimeout(this.init_loader, 10);
        // window.setTimeout(this.load_info_modal, 20);
        window.setTimeout(this.load_info_offcanvas, 20);

        $("#content").on("click", ".filter a", (e) => {
            e.preventDefault();
            var href = $(e.currentTarget).attr("href");
            this.load_content(href);
            $("#next-month-wrapper").show();
        });
        $("#content").on("click", "ul.genres a", (e) => {
            e.preventDefault();
            var href = $(e.currentTarget).attr("href");
            this.load_month(href, e.currentTarget);
        });
        $("#content").on("change", ".filter select", (e) => {
            e.preventDefault();
            var href = window.location.href, data = $(e.currentTarget).closest("form").serialize();
            this.load_content(href + "?" + data);
            $("#next-month-wrapper").hide();
        });
        $("#content").on("click", "a.nxt_mon_link", (e) => {
            e.preventDefault();
            $("div.next_mon_loader").slideDown();
            var href = $(e.currentTarget).attr("href");
            $('<div />').load(href + "&amp;ajax_load=" + (new Date().getTime()) + " #content > *", null, (response, error) => {
                var nxt_mon_events = $(response).find("div.eventMonth");
                if (nxt_mon_events.length > 0) {
                    $("div.eventMonth:last").after(nxt_mon_events).slideDown();
                    $("#next-month-wrapper").replaceWith($(response).find("#next-month-wrapper"));
                    this.scroll_to_lastmon();
                    this.init_loader();
                }
            });
        });
        $("a.top_link").on("click", function (e) {
            e.preventDefault();
            $("html,body").animate({
                scrollTop: 0
            });
        });


        $("a.fullText").on("click", function (e) {
            e.preventDefault();
            document.querySelector("#event-text .collapsed").classList.remove("collapsed")
            $(this).hide();
            $("a.croppedText").show();
        });
        $("a.croppedText").on("click", function (e) {
            e.preventDefault();
            document.querySelector("#event-text > div").classList.add("collapsed")
            $(this).hide();
            $("a.fullText").show();
        });

    },

}
